<template>
    <div class="page-reconciliation-more">
        <PageReconciliationApproved
            :kitId="kitId"
            pageType="more"
        />
        <RealtimeSystemMap/>
    </div>
</template>

<script>
import PageReconciliationApproved from './PageReconciliationApproved.vue';
import ServiceReconciliationTransaction from "../services/ServiceReconciliationV2/ServiceReconciliationTransaction";
import RealtimeSystemMap from "../components/MapV2/RealtimeSystem/RealtimeSystemMap.vue";
export default {
    name: 'PageReconciliationMore',
    components: {
        RealtimeSystemMap,
        PageReconciliationApproved,
    },
    props: {
        kitId: {
            type: String,
            default: ''
        },
        kitTitle: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        isImport: false
    }),
    methods: {
        async onDownload() {
            try {
                const {isTask = true, result: {url = ''}} = await ServiceReconciliationTransaction.exportOfferArchive(this.kitId);

                if(isTask){
                    this.$notify.addNotification({
                        type: 'success',
                        title: 'Экспорт архива',
                        description: 'Создание файла может занять некоторое время. Пожалуйста, подождите.',
                        duration: Infinity,
                        position: 'bottom-right'
                    });
                }else{
                    window.open(url, '_blank');
                }
            }catch (e) {
                this.$notify.addNotification({
                    type: 'error',
                    title: 'Ошибка экспорта',
                    description: e.message,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            }
        },

        onImport() {
            this.isImport = true;
        },

        onCloseModalImport() {
            this.isImport = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .page-reconciliation-more {
        display: flex;
        overflow: hidden;
        flex-direction: column;
        height: 100%;
        // margin: 0 -40px -40px -40px;
        // padding: 0 40px 40px 40px;
        padding: 20px;

        &__menu-tab-list {
            // margin-top: 30px;

            background: #fff;
            margin: 0 -40px 0 -40px;
            padding: 30px 40px 0 40px;
        }
    }
</style>
